"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrictionlessClientUrl = {
    MAC_ALPHA: 'https://s3.amazonaws.com/gb-aurelius-alpha/mac/latest_version/Amazon WorkDocs Companion.pkg',
    MAC_GAMMA: 'https://s3.amazonaws.com/gb-aurelius-gamma/mac/latest_version/Amazon WorkDocs Companion.pkg',
    MAC_PREVIEW: 'https://s3-us-west-2.amazonaws.com/gb-aurelius-preview/mac/latest_version/Amazon WorkDocs Companion.pkg',
    MAC_PROD: 'https://s3-us-west-2.amazonaws.com/gb-aurelius-prod/mac/latest_version/Amazon WorkDocs Companion.pkg',
    WINDOWS_ALPHA: 'https://s3.amazonaws.com/gb-aurelius-alpha/windows/latest_version/Amazon WorkDocs Companion.msi',
    WINDOWS_GAMMA: 'https://s3.amazonaws.com/gb-aurelius-gamma/windows/latest_version/Amazon WorkDocs Companion.msi',
    WINDOWS_PREVIEW: 'https://s3-us-west-2.amazonaws.com/gb-aurelius-preview/windows/latest_version/Amazon WorkDocs Companion.msi',
    WINDOWS_PROD: 'https://s3-us-west-2.amazonaws.com/gb-aurelius-prod/windows/latest_version/Amazon WorkDocs Companion.msi',
};
exports.WS_CONNECT_TIMEOUT_IN_MILLI_SEC = 2000;
